var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import FAIcon from "../FAIcon/FAIcon";
/**
 * To show a Loading indicator while the resource/asset is loading.
 */
const Loading = (_a) => {
    var { size, className, isCentered, addMarginRight } = _a, otherProps = __rest(_a, ["size", "className", "isCentered", "addMarginRight"]);
    const loader = (_jsx(FAIcon, Object.assign({}, otherProps, { className: className, icon: "circle-notch", size: size, title: "Loading", srText: "Loading", addMarginRight: addMarginRight, spin: true })));
    return isCentered ? (_jsx("div", { className: "d-flex w-100 justify-content-center", children: loader })) : (loader);
};
export default Loading;
